var map = {
	"./beruf_digital.jpg": "f40e",
	"./beruf_print.jpg": "9bfc",
	"./geburt_digital.jpg": "4cf3",
	"./geburt_print.jpg": "fcdb",
	"./kinder_digital.jpg": "dc06",
	"./kinder_print.jpg": "a78c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab73";